<template>
  <div id="accordion" v-if="timeline">
    <timeline-group-component v-if="timeline['prequalificacao']" :timeline="timeline['prequalificacao']" groupName="prequalificacao" groupLabel="1. Pré-qualificação"/>
    <timeline-group-component v-if="timeline['iniciado']" :timeline="timeline['iniciado']" groupName="iniciado" groupLabel="2. Iniciado"/>
    <timeline-group-component v-if="timeline['analise']" :timeline="timeline['analise']" groupName="analise" groupLabel="3. Análise"/>
    <timeline-group-component v-if="timeline['contrato']" :timeline="timeline['contrato']" groupName="contrato" groupLabel="4. Contrato"/>
    <timeline-group-component v-if="timeline['verificacao']" :timeline="timeline['verificacao']" groupName="verificacao" groupLabel="5. Verificação"/>
    <timeline-group-component v-if="timeline['aprovacao']" :timeline="timeline['aprovacao']" groupName="aprovacao" groupLabel="6. Aprovação"/>
    <timeline-group-component v-if="timeline['cobranca']" :timeline="timeline['cobranca']" groupName="cobranca" groupLabel="7. Cobrança"/>
  </div>
</template>
<script>
import TimelineGroup from '../../partial/timeline/TimelineGroup.vue'

export default {
  props: ['timeline'],
  components: {
    'timeline-group-component': TimelineGroup
  }
}
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/partial/timeline/Timeline.vue